(function () {
    'use strict';

    function textSearchField() {
        return {
            restrict: 'E',
            scope: {
                attribute: '=',
                changeEvent: '&'
            },
            templateUrl: 'common/directives/templates/textSearchField.html',
            link: function (scope, element, attrs) {
                scope.hasChangeEvent = attrs.changeEvent;

                scope.exists = function (optionPrompt) {
                    return scope.attribute.Options.find(function (option) {
                        return option.Value === optionPrompt && option.Selected;
                    });
                };

                scope.toggle = function(optionPrompt) {
                    var matchingOption = scope.attribute.Options.find(function (option) {
                        return option.Value === optionPrompt });
                    matchingOption.Selected = !matchingOption.Selected;

                    scope.attribute.Value = scope.attribute.Options.filter(
                        function (option) {
                            return option.Selected;
                        }
                    ).map(function (selectedOption) {
                        return selectedOption.Value;
                    });
                }
                // scope.exists = function (item, list) {
                //     if (!list) {
                //         list = [];
                //     }
                //     return list.indexOf(item) > -1;
                // };

                // scope.toggle = function (item, list) {
                //     var index = list.indexOf(item);
                //     if (index > -1)
                //     {
                //         list.splice(index, 1);
                //     }
                //     else
                //     {
                //         list.push(item);
                //     }
                // };
            }
        };
    }

    textSearchField.$inject = [];

    angular.module('ecap.common').directive('textSearchField', textSearchField);
})();